export const KPI_TOOLTIPS = {
  // === Stat Cards ===
  totalRecords:
    "Total condition reports processed through the automation pipeline in the selected time period.",
  automationRate:
    "Percentage of records where all predicted fields met their confidence thresholds, allowing automatic disposition without human review.",
  manualSampleRate:
    "Percentage of automated records randomly selected for human quality-control review. Configured via the manual sample rate in Autoflow settings.",
  criticalAccuracy:
    "Prediction accuracy on critical fields — measured only against records with verified ground-truth labels.",
  truthReceived:
    "Percentage of records that have received verified ground-truth labels, enabling accuracy measurement. Higher coverage improves confidence in accuracy metrics.",

  // === Charts ===
  recordVolume:
    "How records were dispositioned each period: Automated (all fields above threshold), Manual Sample (randomly selected for QC), or Manual Review (at least one field below threshold).",
  automationRateOverTime:
    "Solid area shows rolling average automation rate, smoothing period-to-period variation. Dashed line is the raw per-period rate. A rising trend indicates improving model confidence.",
  automationRateOverRecords:
    "Cumulative automation rate plotted against total records processed. Removes time-based noise from bursty ingestion and shows the trajectory as a function of volume.",
  accuracyOverTime:
    "Model accuracy on critical fields over time. Use the tabs to filter by disposition — all records, automated only, or manual samples. Rolling average smooths per-period variation.",
  accuracyOverRecords:
    "Cumulative accuracy plotted against records processed. Use tabs to filter by disposition. Shows whether accuracy holds as volume grows.",

  // === Sections ===
  perFieldBreakdown:
    "Accuracy and automation rate for each individual predicted field. 'Above Threshold' shows metrics only for predictions that met the configured confidence threshold.",
  confusionMatrices:
    "Cross-tabulates predicted vs. actual labels for each output field. Diagonal cells (green) are correct predictions; off-diagonal (red) are misclassifications. Includes precision, recall, and F1 score per class.",
};
